import Header1 from '@atoms/Header1';
import { Component } from 'solid-js';

export interface SectionHeaderProps {
    title: string;
}

const SectionHeader: Component<SectionHeaderProps> = (props) => {
    const firstWordEnd = props.title.indexOf(' ');
    const emphasizedWord = props.title.substring(0, firstWordEnd);
    const normalText = props.title.substring(firstWordEnd + 1);
    return (
        <>
            <Header1>
                <span class="text-primary">{emphasizedWord}</span> {normalText}
            </Header1>
        </>
    );
};

export default SectionHeader;
